import { lazy, Suspense } from 'react';

type Props = any;

const LazyBakeParentNodeInner = lazy(async () => {
  const { Handle, Position } = await import('reactflow');

  const Comp = ({ label }: { label: string }) => (
    <>
      <Handle type="target" position={Position.Left} />
      <div className="absolute inset-x-0 bottom-full">
        <p className="text-center">{label}</p>
      </div>
      <Handle type="source" position={Position.Right} />
    </>
  );

  return { default: Comp };
});

export const BakeParentNode = ({ data: { label } }: Props) => (
  <Suspense fallback={null}>
    <LazyBakeParentNodeInner label={label} />
  </Suspense>
);
